/* Auth */
export const API_CLIENT_ID = "pz8kb0BFOrRhct2Wlq5mVoPdZnOa0hcsARuVjJbm"; // 'apMm7XXwdbB9E37Qa6ZmR6S3w0OUVddrZ685552j' ==> //v1
export const API_IDENTITY_URL = "https://account.beatport.com";
export const API_SEARCH_URL = "https://api.beatport.com/search/v1";

export const REDIRECT_FORGOT_PASSWORD = null;

/* Colors */
export const TYPE_LIGHT = '#FFFFFF';
export const TYPE_SECONDARY = '#8E8E93'; /* #B2B2B2 */
export const TYPE_PLACEHOLDER = '#808080';
export const TYPE_DARK_SECONDARY = '#CACACA';
export const TYPE_DISABLE = '#444444';
export const BRAND_PRIMARY = '#4EDF84';
export const BRAND_SECONDARY = '#9500FF';
export const BRAND_TERTIARY = '#00BFFF';
export const GREY_1 = '#88898B';
export const GREY_2 = '#DFDFDF';
export const BLACK_2 = '#1F1F1F';
export const BLACK_3 = '#242424';
export const BLACK_5 = '#525252';
export const SYSTEM_BLACK_2 = '#0D0D0D'; //'#020202'; // '#050505';
export const AUTOMIX_PRIMARY = '#9654FA';

/* Covers */
export const OLD_IMG = 'ab2d1d04-233d-4b08-8234-9782b34dcab8';
export const DEFAULT_IMG = 'https://dj.beatport.com/picx/DC.png';
export const DEFAULT_AVATAR = 'https://geo-media.beatport.com/image_size/590x404/0dc61986-bccf-49d4-8fad-6b147ea8f327.jpg';
export const DEFAULT_LABEL = 'https://geo-media.beatport.com/image_size/500x500/cda9862c-cf92-4d13-ac65-7e9277181f51.jpg';

/* Library */
export const MAX_WIDTH = 1410; // Match with the player
export const MAX_HEIGHT_PLAYER = 316; // Match with the player
export const COMPACT_HEIGHT_PLAYER = 95; // Match with the player

export const TAB_BAR_HEIGHT = 0;
export const TAB_BAR_GUTTER = 20;

export const RECENT_TRACKS_LIMIT = 100;

export const LEFT_PAD_TOP = 16; //10;
export const CONTENT_PAD = 16; //30;
export const SIDE_WIDTH = 230;
export const SIDE_WIDTH_CLOSE = 0;
export const CARD_WIDTH = 124;
export const CARD_HEIGHT = 175; // (img size + name + artists)
export const CARD_PAD = 25;
export const GRID_PAD = 15;
export const SUB_SIDEBAR = 192;
export const GRID_WIDTH = window.innerWidth - SIDE_WIDTH - (GRID_PAD * 2);

export const CHART_PAD = 22;
export const CHART_IMAGE_SIZE = 80;
export const FILTERS_PAD = 10;

export const LIST_ROW_HEIGHT = 52;
export const GUTTER_PREVIEW = 20;
export const LIST_ROW_GAP = 2; //3 //0 

export const GRID_ROW_HEIGHT = 160;

export const GRID_TREND_ROWS = 4;
export const GRID_TREND_COLUMNS = 5;
export const GRID_TREND_HEIGHT = 56;

export const GRID_TREND_GENRE_ROWS = 2;
export const GRID_TREND_GENRE_COLUMNS = 5;
export const GRID_TREND_GENRE_HEIGHT = 40;

export const ARTIST_GRID_WIDTH = GRID_WIDTH - SIDE_WIDTH;
export const ARTIST_COLUMNS_MAX = Math.floor(ARTIST_GRID_WIDTH / CARD_WIDTH);

export const PLAYLIST_COVER_SIZE = 102;
export const MENU_COVER_SIZE = 40;
export const TREND_COVER_SIZE = 40;
export const ARTIST_LABEL_COVER_RELEASE = 130;

/* GRID / TREND */
export const GRID_COVER_PAD = 4;
export const GRID_COVER_SIZE = 96;

export const LC_LEFT_PAD = 18;
export const LC_PAD_BETWEEN = 12;

export const STICKY_HEADER_HEIGHT = 112;

/* MODULES */
export const MOD_TOOLTIPS = false;
export const MOD_LINKAGE = true;
export const MOD_PRO = false;
/* Party Mode */
export const PARTYMODE = false;
export const PM_MAX_ACTIVES = 4;
/* Iframe - Post Message */
export const IFRAME = false;
/* Freemium */
export const FREEMIUM = true;
/* Welcome Onboarding */
export const ONBOARDING = false;
/* NOTES / NEWS */
export const MOD_NOTES = false;
/* POPUPS */
export const POPUPS = false;
/* Automix */
export const AUTOMIX_ALL = false;
/* History */
// Breadcrumb history implementation switch.
// true  -> V2 : pur array reducer Redux
//               (append by construction, concurrent-safe, without useReducer ni side-channel).
// false -> V1 : legacy useStoreHistory (useReducer local + pendingHistoryPath side-channel).
export const HISTORY_V2 = true;

/* FOOTER */
export const F_ABOUT_US = null;
export const F_COPYRIGHT = null;
export const F_CONTACT = null;
export const F_CAREERS =  null;
export const F_IMAGES = null;
export const F_SUPPORT = null;
export const F_POLICY = null;
export const F_FEEDBACK = null;
export const F_FEEDBACK_GUEST = null;
export const F_LEGAL = null;
export const F_REDIRECT_NAME = null;
export const F_REDIRECT_URL = null;
export const F_TERMS = null;
export const F_FAQ = null;
export const F_FAQ_HARDWARE = null;
export const F_RELEASE_NOTES = null;

/* SOCIALS */
export const S_FACEBOOK = null;
export const S_TWITTER = null;
export const S_INSTAGRAM = null;
export const S_YOUTUBE = null;
export const S_TWITCH = null;

/* FUNC / OPTIONS */
export const LIMIT_STRING_CAPITALIZE = true;
export const TRENDS_ARTIST_LABEL_MORE = false;
export const GENRES_HAS_FAV = true;
export const GENRES_HAS_CUSTOM_EMPTY = false;
export const ACCESS_STORE = false;
export const HAS_FILTER_EXCLUDE = false;

/* LIST */
export const SHOW_MIX_NAME = true;
export const LIST_HEADER_HAS_REMIXER = true;
export const LIST_HAS_MORE = true;
export const LIST_NAME_WIDTH = '100%';

/* GENRES */
export const GENRES_HAS_TRENDING_LABELS = true;
export const GENRES_CUSTOM_EXTRA_SEARCH_SLUG = [];
export const GENRES_HAS_HYPE = true;
export const GENRES_HAS_EXCLUSIVE = true;

/* SPLAHSCREEN */
export const HAS_SPLASH = true;

/* CART */
export const CART_ITEM_TYPE = 1;
export const CART_AUDIO_FORMAT = 1;
export const CART_PURCHASE_TYPE = 1;
export const CART_SOURCE_TYPE = 28;